/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './BlogList.css';

// Import your images
import ircimagegallery1 from '../images/ircimagegallery1.jpg';
import ircimagegallery2 from '../images/ircimagegallery2.jpg';
import ircimagegallery3 from '../images/ircimagegallery3.jpg';
import ircimagegallery4 from '../images/ircimagegallery4.jpg';
import ircimagegallery5 from '../images/ircimagegallery5.jpg';
import ircimagegallery6 from '../images/ircimagegallery6.jpg';
import ircimagegallery7 from '../images/ircimagegallery7.jpg';
import ircimagegallery8 from '../images/ircimagegallery8.jpg';
import ircimagegallery9 from '../images/ircimagegallery9.jpg';
import ircimagegallery10 from '../images/ircimagegallery10.jpg';
import ircimagegallery11 from '../images/ircimagegallery11.jpg';
import ircimagegallery12 from '../images/ircimagegallery12.jpg';

const ImageGallery = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isSliderOpen, setIsSliderOpen] = useState(false);
  const [loadedImages, setLoadedImages] = useState(new Set());

  // Image data with descriptions
  const imageList = [
    {
      id: 1,
      image: ircimagegallery1,
      category: 'community',
      title: 'Inauguration of IRC Arabic Academy',
      description: 'A vibrant community event bringing people together for cultural exchange and shared experiences.'
    },
    {
      id: 2,
      image: ircimagegallery2,
      category: 'community',
      title: 'Free Water Supply',
      description: 'Volunteers and staff participating in team-building activities to strengthen community bonds.'
    },
    {
      id: 3,
      image: ircimagegallery3,
      category: 'education',
      title: 'Summer Camp Certificate Distribution',
      description: 'Interactive educational workshop focusing on skill development and knowledge sharing.'
    },
    {
      id: 4,
      image: ircimagegallery4,
      category: 'education',
      title: 'Free Ration Kits Distribution',
      description: 'Students engaged in hands-on learning activities with dedicated instructors.'
    },
    {
      id: 5,
      image: ircimagegallery5,
      category: 'events',
      title: 'Inauguration of Minority Development Centre',
      description: 'Our annual community celebration featuring cultural performances and festivities.'
    },
    {
      id: 6,
      image: ircimagegallery6,
      category: 'community',
      title: 'Md Shahnewaj Deputy Commander Rapid Action Force Visited IRC Head Office',
      description: 'Community members enjoying outdoor recreational activities and nature exploration.'
    },
    {
      id: 7,
      image: ircimagegallery7,
      category: 'events',
      title: 'Inauguration of IRC Technical Institute',
      description: 'A special fundraising event supporting local community initiatives and programs.'
    },
    {
      id: 8,
      image: ircimagegallery8,
      category: 'education',
      title: 'Certificate Distribution of IRC Technical Institute',
      description: 'Professional development workshop for educators and community leaders.'
    },
    {
      id: 9,
      image: ircimagegallery9,
      category: 'events',
      title: 'IRC Pathfinder Program',
      description: 'Multicultural festival celebrating diversity and heritage through art and music.'
    },
    {
      id: 10,
      image: ircimagegallery10,
      category: 'community',
      title: 'Free Distribution of Books & NoteBooks',
      description: 'Community volunteer day with participants contributing to local improvement projects.'
    },
    {
      id: 11,
      image: ircimagegallery11,
      category: 'events',
      title: 'IRC 10-Days Conference',
      description: 'Professional networking event connecting community members and local businesses.'
    },
    {
      id: 12,
      image: ircimagegallery12,
      category: 'education',
      title: 'Free Ration Kits Distribution',
      description: 'Comprehensive training program for new volunteers and community organizers.'
    },
  ];

  const categories = ['all', ...new Set(imageList.map(image => image.category))];
  const filteredImages = activeCategory === 'all'
    ? imageList
    : imageList.filter(image => image.category === activeCategory);

  const openSlider = (index) => {
    setCurrentSlide(index);
    setIsSliderOpen(true);
    document.body.style.overflow = 'hidden'; // Prevent background scrolling
  };

  const closeSlider = () => {
    setIsSliderOpen(false);
    document.body.style.overflow = 'auto'; // Restore scrolling
  };

  const goToPrevious = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? filteredImages.length - 1 : prev - 1
    );
  };

  const goToNext = () => {
    setCurrentSlide((prev) =>
      prev === filteredImages.length - 1 ? 0 : prev + 1
    );
  };

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isSliderOpen) return;

      switch (e.key) {
        case 'Escape':
          closeSlider();
          break;
        case 'ArrowLeft':
          goToPrevious();
          break;
        case 'ArrowRight':
          goToNext();
          break;
        default:
          break;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isSliderOpen]);

  const handleReload = () => {
    window.scrollTo(0, 0);
  };

  const handleImageLoad = (imageId) => {
    setLoadedImages(prev => new Set(prev).add(imageId));
  };

  const isImageLoaded = (imageId) => {
    return loadedImages.has(imageId);
  };

  return (
    <section className="gallery-section">
      <div className="gallery-container">
        <div className="media-header">
          <h2 className="gallery-title">IRC Image Gallery</h2>
          <Link to="" target='_parent' className="activities-button" onClick={handleReload}>
            View All Gallery
          </Link>
        </div>
        <p className="gallery-subtitle">
          Browse through our collection of images from various events and activities.
        </p>

        {/* Filters */}
        <div className="gallery-filters">
          {categories.map(category => (
            <button
              key={category}
              className={`filter-btn ${activeCategory === category ? 'active' : ''}`}
              onClick={() => setActiveCategory(category)}
            >
              {category.charAt(0).toUpperCase() + category.slice(1)}
            </button>
          ))}
        </div>

        {/* Image Grid */}
        <div className="gallery-grid">
          {filteredImages.map((image, index) => (
            <div
              key={image.id}
              className="gallery-item"
              onClick={() => openSlider(index)}
              style={{ cursor: 'pointer' }}
            >
              <div className="image-container">
                <img
                  src={image.image}
                  className={`gallery-image ${isImageLoaded(image.id) ? 'loaded' : ''}`}
                  loading="lazy"
                  onLoad={() => handleImageLoad(image.id)}
                  alt={image.title}
                />
                {!isImageLoaded(image.id) && (
                  <div className="image-placeholder">
                    <div className="loading-spinner"></div>
                    <span>Loading...</span>
                  </div>
                )}
              </div>
              {/* Title overlay on hover */}
              <div className="image-overlay">
                <div className="image-caption">{image.title}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Image Slider - Manual Navigation Only */}
      {isSliderOpen && (
        <div className="image-slider active" onClick={closeSlider}>
          <div className="slider-content" onClick={e => e.stopPropagation()}>
            {/* Close button */}
            <button className="slider-close-btn" onClick={closeSlider}>
              &times;
            </button>

            {/* Navigation buttons - Manual only */}
            <button
              className="slider-nav-btn prev-btn"
              onClick={(e) => {
                e.stopPropagation();
                goToPrevious();
              }}
              aria-label="Previous image"
            >
              &#10094;
            </button>

            <button
              className="slider-nav-btn next-btn"
              onClick={(e) => {
                e.stopPropagation();
                goToNext();
              }}
              aria-label="Next image"
            >
              &#10095;
            </button>

            {/* Main image with title overlay */}
            <div className="slider-image-container">
              <img
                src={filteredImages[currentSlide].image}
                className="slider-main-image"
                alt={filteredImages[currentSlide].title}
                loading="eager"
              />

              {/* Title overlay on the image */}
              <div className="slider-image-title-overlay">
                <h3 className="slider-image-title-text">
                  {filteredImages[currentSlide].title}
                </h3>
              </div>
            </div>

            {/* Image info - You can keep this or remove it if title is on image */}
            {/* <div className="slider-info">
              <p className="slider-image-description">
                {filteredImages[currentSlide].description}
              </p>
              <div className="slider-image-counter">
                Image {currentSlide + 1} of {filteredImages.length}
              </div>
            </div> */}

            {/* Thumbnail navigation - Manual click only */}
            {/* <div className="slider-thumbnails">
              {filteredImages.map((img, index) => (
                <div
                  key={img.id}
                  className={`thumbnail-item ${index === currentSlide ? 'active' : ''}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    goToSlide(index);
                  }}
                  role="button"
                  tabIndex={0}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.stopPropagation();
                      goToSlide(index);
                    }
                  }}
                >
                  <img
                    src={img.image}
                    alt={`Thumbnail ${index + 1}`}
                    className="thumbnail-image"
                  />
                </div>
              ))}
            </div> */}
          </div>
        </div>
      )}
    </section>
  );
};

export default ImageGallery;